import Vue from 'vue'
import App from './App'
import router from './router'
import Swiper from 'vue-swiper'

// import Element from 'element-ui'
// import 'element-ui/lib/theme-default/index.css'
// Vue.use(Element)

import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App, Swiper }
})



// WEBPACK FOOTER //
// ./src/main.js